import { CapacitorHttp, HttpResponse } from '@capacitor/core';
import { PREFER, RESPONSE_STATUS_ACCEPTED } from '../../../constants';
import { Headers } from '../../types/types';
import { pollLongRunningOperation } from './pollLongRunningOperation';

// Runs the long-running operation poll loop only when opted in; otherwise
// passes the response through untouched. Re-queries the Location URL via a
// plain GET without the Prefer header. The abort signal is owned by the caller
// (registered before the initial request) so navigation that happens while the
// initial request is still in flight also cancels the poll that follows.
export const processPollLongRunningOperation = (
  response: HttpResponse,
  longRunning: boolean | undefined,
  requestHeaders: Headers,
  signal?: AbortSignal
): Promise<HttpResponse> | HttpResponse => {
  if (!longRunning || response.status !== RESPONSE_STATUS_ACCEPTED) {
    return response;
  }

  const pollLocation = (locationUrl: string): Promise<HttpResponse> => {
    const pollHeaders = { ...requestHeaders };
    delete pollHeaders[PREFER];
    return CapacitorHttp.request({
      url: locationUrl,
      method: 'GET',
      headers: pollHeaders,
    });
  };

  return pollLongRunningOperation(response, pollLocation, signal);
};
